import { Component, inject } from '@angular/core';

import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  private readonly spinnerService = inject(SpinnerService);
  readonly isVisible = this.spinnerService.isVisible;
}
